import React from 'react';
type SectionProps = {
  tone: 'ink' | 'wine';
  id?: string;
  className?: string;
  children: React.ReactNode;
};
export function Section({
  tone,
  id,
  className = '',
  children
}: SectionProps) {
  return <section id={id} className={`${tone === 'ink' ? 'bg-ink' : 'bg-wine'} py-16 md:py-24`} data-id="element-47" data-mp="3fx6s3ucoc3gu">
      <div className={`mx-auto w-full max-w-[720px] px-6 ${className}`} data-id="element-48" data-mp="3kuyiul1l1jjg">{children}</div>
    </section>;
}
export function SectionTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h2 className={`font-serif text-[2.5rem] font-medium leading-[1.08] text-ivory md:text-[3.25rem] ${className}`} data-id="element-49" data-mp="hdgewooxkwob">
      {children}
    </h2>;
}